<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'
import IconBox, { type IconBoxSize } from './IconBox.vue'
import type { PiIconName } from '@uiKit/elements/PiIcon.vue'

interface Props {
  icon?: PiIconName
  iconBg?: string
  iconColor?: string
  iconSize?: IconBoxSize
  label: string
  value: string
  truncateValue?: boolean
}

withDefaults(defineProps<Props>(), {
  iconSize: 'xl',
  truncateValue: false,
})
</script>

<template>
  <Box flex align="center" gap="3" padding="4" class="detail-row">
    <IconBox v-if="icon" :icon="icon" :size="iconSize" :bg="iconBg" :icon-color="iconColor" />
    <Box direction="col" gap="1" grow class="detail-row__text">
      <Text type="caption" color="muted">{{ label }}</Text>
      <Text type="subheading" :truncate="truncateValue">{{ value }}</Text>
    </Box>
    <slot name="action" />
  </Box>
</template>

<style scoped>
.detail-row {
  background: var(--p-surface-0);
}

.detail-row__text {
  min-width: 0;
}
</style>
